import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  root: {
    width: 400,
    maxWidth: "100vw",
    height: 40,
    // Allow the Autocomplete to shrink below its natural min-content
    // inside the narrow-desktop `topCenter` flex parent. Without this
    // the input resists compression and pushes the sibling "View site"
    // button (which has flexShrink: 0) past the header's right edge.
    minWidth: 0,
    // Lock the outlined wrapper to 40px so the field aligns with the
    // contained "View site" button (also 40px) on a single top-nav baseline.
    "& .MuiOutlinedInput-root": {
      height: 40,
      minHeight: 40,
    },
    "& .MuiAutocomplete-inputRoot .MuiAutocomplete-input": {
      height: 16,
    },
    // Keep the magnifying-glass icon upright when the dropdown opens.
    "& .MuiAutocomplete-popupIndicator, & .MuiAutocomplete-popupIndicatorOpen": {
      transform: "none",
    },
    [theme.breakpoints.down('lg')]: {
      // 900–1200px narrow desktop: the flex parent (`topCenter`) is only
      // ~510–640px wide after the 225px logo, 48px avatar button, and
      // the 60px margin spec are subtracted. Alongside the non-shrinking
      // 110px "View site" button and the 280px agency selector, 400px
      // here overflows the header on the right. 300 leaves enough slack
      // for the selector to stay legible without clipping.
      width: 300,
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: "100%",
    },
  },
  textFieldLabel: {
    lineHeight: "25px",
    [theme.breakpoints.down('md')]: {
      lineHeight: "normal",
    },
  },
  popupIcon: {
    color: "#8D98C2",
    fontSize: 20,
    // Override the default Autocomplete popup-icon rotation so the
    // magnifying glass stays upright when the dropdown opens.
    transform: "none !important",
  },
}));
